<template>
  <button
    v-if="canClear"
    type="button"
    class="btn btn-link clear-filters"
    @click="onClear"
  >x {{translate('desClearAllFilters')}}</button>
</template>

<script>

export default {
  name: 'ClearFilters',
  props: {
    canClear: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClear () {
      this.$emit('clear')
    }
  }
}
</script>
